<template>
	<div class="home">
		<!-- banner -->
		<section class="banner">
			<swiper :options="swiperOption" ref="mySwiper" @someSwiperEvent="callback">
				<swiper-slide class="swiper-slide" v-for="(item, index) in bannerList" :key="index"><img v-on:click="GoUrl(item.Url)" v-lazy="item.CoverStr" /></swiper-slide>

				<div class="swiper-pagination bannerSpan" slot="pagination"></div>
			</swiper>

			<!-- 2.22新增 -->
			<article class="home-logoin" v-if="sidebar.IsUseRegistPicture">
				<img v-lazy="sidebar.RegistPicture" />
				<h6 class="flexCenter">
					<span></span>
					{{ setInfo.LoginName }}
					<span></span>
				</h6>
				<div class="hpme_form">
					<div class="hpme_li flexFloat">
						<input type="number" placeholder="输入分数" />
						<span>分</span>
					</div>
					<div class="hpme_li flexFloat">
						<input type="number" placeholder="输入位次" />
						<span>位</span>
					</div>

					<div class="hpme_ke">
						<p>选择科目</p>
						<div class="hpme_duo flex wrap">
							<el-checkbox-group v-model="checkList" :max="3">
								<el-checkbox label="理科或物理"></el-checkbox>
								<el-checkbox label="文科或历史"></el-checkbox>
								<el-checkbox label="化学"></el-checkbox>
								<el-checkbox label="生物"></el-checkbox>
								<el-checkbox label="地理"></el-checkbox>
								<el-checkbox label="技术"></el-checkbox>
								<el-checkbox label="政治"></el-checkbox>
							</el-checkbox-group>
						</div>
					</div>
					<div class="hpme_btn shou" @click="gozntb('Voluntary', '/xzTianBaoIndex', 0)">智能填报</div>
				</div>
			</article>

			<!-- 2022-2-22注释 -->
			<!-- <article class="home-logoin">
                <img v-lazy="sidebar.RegistPicture" />
                <div style="position: relative;z-index: 2;">
                    <div class="home-lgtit">{{ setInfo.LoginName }}</div>
                    <div class="banner-right" v-if="user.user">
                        <div class="banner-right-c01">
                            <span>学生姓名：{{ user.user.Name }}</span>
                        </div>
                        <div class="banner-right-c01">
                            <span>所在省份：{{ user.user.Province }}</span>
                        </div>
                        <div class="banner-right-c01">
                            <span>性别：{{ user.user.Gender === 1 ? '男' : '女' }}</span>
                        </div>
                        <div class="banner-right-c01">
                            <span>高考年份：{{ user.user.CollegeYear }}</span>
                        </div>
                    </div>
                    <div class="banner-right" v-else>
                        <div class="banner-right-c01">
                            <img src="../image/home-a.png" />
                            <input placeholder="请输入手机号码" v-model.trim="loginModel.Phone" />
                        </div>
                        <div class="banner-right-c01">
                            <img src="../image/home_b.png" />
                            <input :type="isSee ? 'passWord' : 'text'" placeholder="请输入登录密码" v-model.trim="loginModel.Password" />
                            <img style="cursor: pointer;" :src="isSee ? require('../image/home_cc.png') : require('../image/home_c.png')" @click="seeClick()" />
                        </div>
                        <div class="banner-right-c01" @click="stateBtn">
                            <img :src="rememberLoginState ? require('../image/home-dd.png') : require('../image/home-d.png')" />
                            <span>记住登录状态</span>
                        </div>
                    </div>
                    <button class="banner-right-btn" v-if="user.user" @click="goMyCenter">进入个人中心</button>
                    <template v-else>
                        <button class="banner-right-btn" @click="login">登录</button>
                        <div class="banner-rfoot">
                            <p @click="passWord">忘记密码</p>
                            <p @click="regsit">立即注册</p>
                        </div>
                    </template>
                </div>
            </article> -->
		</section>

		<!-- 视频 -->
		<div class="pvideo flex zhong center" v-if="hostVideo.IsPublish">
			<img v-lazy="hostVideo.PictureStr" />
			<video width="1000" height="550" controls>
				<source :src="hostVideo.Video" type="video/mp4" />
				<source :src="hostVideo.Video" type="video/ogg" />
				您的浏览器不支持 video 标签。
			</video>
		</div>

		<!-- 2.22 add -->
		<div class="home_icon flex wrap">
			<div class="home_icon_li" v-for="(item, index) in cardList" :key="index">
				<img :src="item.Icon || ''" />
				<div class="flexCenter ">
					<el-dropdown>
						<span class="el-dropdown-link shou">
							{{ item.Title }}
							<i class="el-icon-caret-bottom"></i>
						</span>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item v-for="(item1, index1) in item.Children" :key="index1">
								<span @click="gozntb(item1.Key, item1.path, item1.setId)" style="display:block;">{{ item1.Title }}</span>
							</el-dropdown-item>
							<!-- <el-dropdown-item>
								<span @click="gozntb('NewEvaluation')" style="display:block;">新高考选科测评</span>
							</el-dropdown-item>
							<el-dropdown-item>
								<span @click="gozntb('Major')" style="display:block;">根据科目选专业</span>
							</el-dropdown-item>
							<el-dropdown-item>
								<span @click="gozntb('Subject')" style="display:block;">根据专业选科目</span>
							</el-dropdown-item> -->
						</el-dropdown-menu>
					</el-dropdown>
				</div>
			</div>
		</div>

		<!-- neirong -->
		<section class="homeNei">
			<article class="home_saas " v-if="homePicture.FirstShow"><img v-lazy="homePicture.FirstPicture" /></article>
			<article class="home_saas " v-if="homePicture.SecondShow"><img v-lazy="homePicture.SecondPicture" /></article>
			<article class="home_saas " v-if="homePicture.ThirdShow"><img v-lazy="homePicture.ThirdPicture" /></article>
			<article class="home_saas " v-if="homePicture.FourShow"><img v-lazy="homePicture.FourPicture" /></article>
			<article class="home_saas " v-if="homePicture.FiveShow"><img v-lazy="homePicture.FivePicture" /></article>
			<article class="home_saas " v-if="homePicture.SixShow"><img v-lazy="homePicture.SixPicture" /></article>

			<!-- 媒体查询 -->
			<article class="home_mei widthz">
				<!-- <img src="../image/mei.png" /> -->
				<!-- <h4>招生运营</h4> -->
				<section class="recruit flex float">
					<!-- recruit-left -->
					<div class="recruit-left">
						<div v-for="(item, index) in ProjectSetList" :key="index">
							<!-- 服务项目 -->
							<div class="recruit-left-c01" v-if="IsShowService && item.type == 1">
								<div class="rct-left-tit">
									<p>{{ ServiceName }}</p>
								</div>
								<ul class="project-list">
									<li v-for="(item1, index1) in projectList" :key="index1" @click="fuwuTo(item1.Id)">
										<div class="pj-img"><img v-lazy="item1.CoverStr" /></div>
										<p class="pj-name">{{ item1.Name }}</p>
									</li>
								</ul>
							</div>
							<!-- 录播课堂 -->
							<div class="recruit-left-c01" v-if="IsShowClassroom && item.type == 2">
								<div class="rct-left-tit">
									<p>{{ ClassroomName }}</p>
								</div>
								<ul class="project-list">
									<li v-for="(item2, index2) in classroomList" :key="index2" @click="luboTo(item2.Id)">
										<div class="pj-img"><img v-lazy="item2.CoverStr" /></div>
										<div class="pj-tit flex zhong float">
											<p>{{ item2.Name }}</p>
											<div class="pj-num">
												<img src="../image/zs_see.png" />
												<span>{{ item2.WatchNumber+ item2.RealWatchNumber}}</span>
											</div>
										</div>
									</li>
								</ul>
							</div>
							<!-- 头条资讯 -->
							<div class="recruit-left-c01" v-if="IsShowHeadlines && item.type == 5">
								<div class="rct-left-tit flex zhong float">
									<p>{{ HeadlinesName }}</p>
									<div class="left-tit-more" @click="moreTo()">
										<span>更多</span>
										<img src="../image/zs_more.png" />
									</div>
								</div>
								<ul class="new-list">
									<li v-for="(item3, index3) in newList" :key="index3" v-on:click="headDetails(item3.Id)">
										<div class="new-img"><img v-lazy="item3.PictureStr" /></div>
										<div class="new-con">
											<div class="new-ctit">{{ item3.Name }}</div>
											<div class="new-ctxt">{{ item3.ReadNum }}</div>
										</div>
									</li>
								</ul>
							</div>
						</div>
						<!-- 媒体报道 -->
						<!-- <div class="recruit-left-c01" v-if="IsShowMedia">
							<div class="rct-left-tit flex zhong float">
								<p>{{ MediaName }}</p>
								<div class="left-tit-more" @click="media()">
									<span>更多</span>
									<img src="../image/zs_more.png" />
								</div>
							</div>
							<ul class="new-list">
								<li v-for="(item, index) in meiList" :key="index" @click="details(item.Id)">
									<div class="new-img"><img :src="item.PcCoverStr" /></div>
									<div class="new-con">
										<div class="new-ctit">{{ item.Title }}</div>
										<div class="new-ctxt">{{ item.Describle }}</div>
									</div>
								</li>
							</ul>
						</div> -->
					</div>
					<!-- recruit-right -->
					<div class="recruit-right">
						<div v-for="(item, index) in ProjectSetList" :key="index">
							<article class="pright_top" v-if="IsShowAppointment && item.type == 3">
								<section class="pright_head flex zhong float">
									<h6>{{ AppointmentName }}</h6>
									<figure class="flex zhong" @click="zhuanjiaTo()">
										<figcaption>更多</figcaption>
										<img src="../image/zs_more.png" />
									</figure>
								</section>
								<ul>
									<li class="flex zhong float" v-for="(item, index) in zhuanLeft" :key="index">
										<img v-lazy="item.HeadImgStr" />
										<hgroup>
											<h6>{{ item.Name }}</h6>
											<p>{{ item.Profit }}</p>
										</hgroup>
									</li>
								</ul>
							</article>
							<article class="pright_top pright_huo" v-if="IsShowActivity && item.type == 4">
								<section class="pright_head flex zhong float">
									<h6>{{ ActivityName }}</h6>
								</section>
								<div class="phuo_gao">
									<dl>
										<dd v-for="(item, index) in prightDd" :key="index" @click="huodongTo(item.Id)">
											<img :src="item.CoverStr" />
											<h1>{{ item.Name }}</h1>
											<figure class="flex zhong">
												<img src="../image/zs_time.png" />
												<figcaption>{{ item.BeginTime }}~{{ item.EndTime }}</figcaption>
											</figure>
											<figure class="flex zhong">
												<img src="../image/zs_phone.png" />
												<figcaption>{{ item.Phone }}</figcaption>
											</figure>
										</dd>
									</dl>
								</div>
							</article>
						</div>
					</div>
				</section>
			</article>

			<!-- 媒体查询 -->
			<article class="home_mei widthz" v-if="IsShowMedia">
				<!-- <img src="../image/mei.png" /> -->
				<h4>{{ MediaName }}</h4>
				<div class="home_mei_div flex float">
					<div class="home_mei_left" v-if="firstMei" @click="details(firstMei.Id)">
						<img v-lazy="firstMei.PcCoverStr" />
						<hgroup>
							<h6>{{ firstMei.Title }}</h6>
							<p>
								<span>{{ firstMei.Describle }}</span>
								<i @click="details(firstMei.Id)">[查看更多]</i>
							</p>
						</hgroup>
					</div>
					<div class="home_mei_right">
						<ul>
							<li class="flex float" v-for="(item, index) in meiList" :key="index" @click="details(item.Id)">
								<div class="hmei_pic"><img v-lazy="item.PcCoverStr" /></div>
								<hgroup>
									<h6>{{ item.Title }}</h6>
									<p>{{ item.Describle }}</p>
								</hgroup>
							</li>
						</ul>
					</div>
				</div>
				<div class="zhong flex center hmei_fg" @click="media()">
					<p>更多</p>
					<img src="../image/you.png" />
				</div>
			</article>

			<article class="home_saas home-apply-con" v-if="sidebar.ShopId == 0">
				<img v-lazy="sidebar.BasePicture" />
				<div class="home-apply">
					<div class="home-apply-left">
						<div class="apply-left-li">
							<img src="../image/bha.png" />
							<p class="apply-left-c01">
								<span v-if="sidebar.ShopId == 0">咨询老师：{{ sidebar.Name }}</span>
								<span class="on-phone">{{ sidebar.Phone }}</span>
							</p>
						</div>
						<button v-if="sidebar.ShopId == 0" @click="shenqingBtn">立即申请</button>
					</div>
					<div class="home-apply-right">
						<img v-lazy="sidebar.WeChartImg" />
						<!-- <span>直通车</span> -->
					</div>
				</div>
			</article>
		</section>

		<!-- 联系客服 -->
		<aside-fixed></aside-fixed>

		<!-- 申请弹窗 -->
		<div class="popup" v-show="isShenqin">
			<div class="serve-popup animated fadeIn">
				<div class="serve-pop-del"><img @click="closeApply" src="../image/vol-del-t.png" /></div>
				<ul class="serve-pop-from">
					<li>
						<span>用户名</span>
						<input v-model="name" placeholder="请输入用户名" />
					</li>
					<li>
						<span>电话</span>
						<input v-model="phone" placeholder="请输入电话号码" />
					</li>
					<li>
						<span>验证码</span>
						<input class="li-inp" v-model="code" placeholder="请输入验证码" />
						<p @click="GetCode()" class="code-btn">
							<span v-show="show">获取验证码</span>
							<span v-show="!show" class="count">重新获取{{ count }}s</span>
						</p>
					</li>
				</ul>
				<button class="serve-pop-btn" v-on:click="SubmitSave">提交</button>
			</div>
		</div>

	</div>
</template>

<script>
import Cookies from 'js-cookie';
import { getToken } from '../utils/getToken';
import { mapState } from 'vuex';
import asideFixed from '@/components/global/aside/aside.vue';
const TIME_COUNT = 60;
export default {
	components: {
		asideFixed
	},
	name: 'home',
	data() {
		return {
			KeyList: [
				{
					name: '新高考选科测评',
					parent: '新高考选科测评',
					englishName: 'NewEvaluation',
					path: '/gaokao',
					id: 1
				},
				{
					name: '根据科目选专业',
					parent: '新高考选科测评',
					englishName: 'Major',
					path: '/major',
					id: 0
				},
				{
					name: '根据专业选科目',
					parent: '新高考选科测评',
					englishName: 'Subject',
					path: '/subject',
					id: 0
				},
				{
					name: '升学规划测评',
					parent: '升学规划测评',
					englishName: 'Entrance',
					path: '/way',
					id: 2
				},
				{
					name: '升学途径指南',
					parent: '升学规划测评',
					englishName: 'Guide',
					path: '/guide',
					id: 0
				},
				{
					name: '学习风格测评',
					parent: '学业规划测评',
					englishName: 'Style',
					path: '/style',
					id: 3
				},
				{
					name: '学习时间管理测评',
					parent: '学业规划测评',
					englishName: 'LearningTime',
					path: '/style',
					id: 4
				},
				{
					name: '学习心理调节测评',
					parent: '学业规划测评',
					englishName: 'Psychological',
					path: '/style',
					id: 5
				},
				{
					name: '学业情绪管理测评',
					parent: '学业规划测评',
					englishName: 'EmotionManage',
					id: 6,
					path: '/style'
				},
				{
					name: '学习态度、方法和能力综合测评',
					parent: '学业规划测评',
					englishName: 'Comprehensive',
					id: 7,
					path: '/style'
				},
				{
					name: '学习习惯测评',
					parent: '学业规划测评',
					englishName: 'Habit',
					id: 8,
					path: '/style'
				},
				{
					name: '学习动机诊断测评',
					parent: '学业规划测评',
					englishName: 'Motivation',
					id: 9,
					path: '/style'
				},
				{
					name: 'Sarason考试焦虑测评',
					parent: '学业规划测评',
					englishName: 'StudySarason',
					id: 10,
					path: '/style'
				},
				{
					name: '师生和同学关系测评',
					parent: '学业规划测评',
					englishName: 'Relationship',
					path: '/style',
					id: 11
				},
				{
					name: '专业定位测评',
					parent: '职业规划测评',
					englishName: 'Orientation',
					path: '/style',
					id: 13
				},
				{
					name: '施恩职业锚测评',
					parent: '职业规划测评',
					englishName: 'ShiEn',
					id: 14,
					path: '/style'
				},
				{
					name: '气质测评',
					parent: '职业规划测评',
					englishName: 'Temperament',
					id: 15,
					path: '/style'
				},
				{
					name: '舒伯职业价值观测评',
					parent: '职业规划测评',
					englishName: 'Shubo',
					id: 16,
					path: '/style'
				},
				{
					name: '心理适应性测评',
					parent: '职业规划测评',
					englishName: 'Usability',
					id: 17,
					path: '/style'
				},
				{
					name: '自信心测评',
					parent: '职业规划测评',
					englishName: 'Confidence',
					id: 18,
					path: '/style'
				},
				{
					name: 'EQ情商测评',
					parent: '职业规划测评',
					englishName: 'EQ',
					id: 19,
					path: '/style'
				},
				{
					name: 'DISC个性测评',
					parent: '职业规划测评',
					englishName: 'DISC',
					id: 20,
					path: '/style'
				},
				{
					name: 'PDP性格测评',
					parent: '职业规划测评',
					englishName: 'ProfessionalPDP',
					id: 21,
					path: '/style'
				},
				{
					name: '学生学情档案',
					parent: '学生学情档案',
					englishName: 'ArchivesPDP',
					path: '/fileindex',
					id: 0
				},
				{
					name: '家长情况测评',
					parent: '家长情况测评',
					englishName: 'ParentPDP',
					path: '/style',
					id: 12
				},
				{
					name: '查：高校分数线',
					parent: '高效查',
					englishName: 'UniversityScore',
					path: '/lastIndex',
					id: 0
				},
						{
			name: '查：专业分数线',
					parent: '高效查',
					englishName: 'MajorScore',
					path: '/majorScore',
					id: 0
				},
				{
					name: '查：省控分数线',
					parent: '高效查',
					englishName: 'Provincial',
					path: '/skScore',
					id: 0
				},
				{
					name: '查：一分一段表',
					parent: '高效查',
					englishName: 'Paragraph',
					path: '/scoreTable',
					id: 0
				},
				{
					name: '查：高校查询',
					parent: '高效查',
					englishName: 'University',
					path: '/lastSchool',
					id: 0
				},
				{
					name: '查：大学排名',
					parent: '高效查',
					englishName: 'UniversityRank',
					path: '/lastRanking',
					id: 0
				},
				{
					name: '查：专业查询',
					parent: '高效查',
					englishName: 'ProfessionalInquiry',
					path: '/lastMajor',
					id: 0
				},
				{
					name: '查：职业查询',
					parent: '高效查',
					englishName: 'OccupationInquiry',
					path: '/occupation',
					id: 0
				},
				{
					name: '查：招生章程',
					parent: '高效查',
					englishName: 'Admission',
					path: '/constitution',
					id: 0
				},
				{
					name: '填：智能选院校',
					parent: '精准填',
					englishName: 'Colleges',
					path: '/znYuan',
					id: 0
				},
				{
					name: '填：智能选专业',
					parent: '精准填',
					englishName: 'MajorSelect',
					path: '/znZhuan',
					id: 0
				},
				{
					name: '填：录取风险评估',
					parent: '精准填',
					englishName: 'AdmissionRisk',
					path: '/assessment',
					id: 0
				},
				{
					name: '填：同分数考生去向',
					parent: '精准填',
					englishName: 'Whereabout',
					path: '/lastGo',
					id: 0
				},
				{
					name: '填：一键志愿填报',
					parent: '精准填',
					englishName: 'Voluntary',
					path: '/xzTianBaoIndex',
					id: 0
				},
				{
					name: '填：高职专科填报',
					parent: '精准填',
					englishName: 'Voluntary2',
					path: '/xzTianBaoIndex',
					id: 0
				},
				{
					name: '家庭学习与支持',
					parent: '家庭教育测评',
					englishName: 'FamilyStudy',
					id: 23,
					path: '/jthomeJiaTing'
				},
				{
					name: '亲子关系',
					parent: '家庭教育测评',
					englishName: 'ParentChildRelationship',
					id: 24,
					path: '/jthomeQinZi'
				},
				{
					name: '家庭环境',
					parent: '家庭教育测评',
					englishName: 'FamilyEnvironment',
					id: 25,
					path: '/jthomeHuanJing'
				},
				{
					name: '家庭功能',
					parent: '家庭教育测评',
					englishName: 'FamilyFunction',
					id: 26,
					path: '/jthomeGongNeng'
				},
				{
					name: '青少年上网成瘾自评',
					parent: '家庭教育测评',
					englishName: 'TeenagerAddicted',
					id: 27,
					path: '/jthomeeZiPing'
				},
				{
					name: '新高考选科测评卡',
					parent: '考研',
					englishName: 'NewEvaluationCard',
					id: 1,
					path: '/kyStudyGaoKao'
				},
				{
					name: '升学规划测评卡',
					parent: '考研',
					englishName: 'EntranceCard',
					id: 2,
					path: '/kyStudyShengXue'
				},
				{
					name: '学业规划测评卡',
					parent: '考研',
					englishName: 'StudyCard',
					id: 3,
					path: '/kyStudyGuiHua'
				},
				{
					name: '职业规划测评卡',
					parent: '考研',
					englishName: 'ProfessionCard',
					id: 4,
					path: '/kyStudyZhiYe'
				},
				{
					name: '考研',
					parent: '考研',
					englishName: 'ExamCard',
					id: 5,
					path: '/kyStudyKaoYan'
				},
				{
					name: '课程VIP',
					parent: '课程VIP卡',
					englishName: 'TeenagerAddicted',
					id: 0,
					path: '/myClassVip'
				}
			],
			checkList: [],
			// 以上2.22
			isUser: true,
			// 记住登录状态
			rememberLoginState: false,
			// 已保存的登录信息
			loginInfoModel: null,
			// 登录信息
			loginModel: {
				Phone: '',
				Password: ''
			},
			bannerList: [],
			swiperOption: {
				spaceBetween: 30,
				centeredSlides: true,
				autoplay: {
					delay: 2500,
					disableOnInteraction: false
				},
				pagination: {
					el: '.swiper-pagination',
					clickable: true
				}
			},
			// meiList
			meiList: [],
			firstMei: {},
			homePicture: {},
			sidebar: {},
			setInfo: {},
			isSee: true,
			newsTitle: '媒体报告',
			// 是否登录
			isLogin: true,
			// 倒计时
			show: true,
			count: '',
			timer: null,
			// 申请弹窗
			isShenqin: false,
			phone: '',
			name: '',
			code: '',
			backCode: '',
			isClick: false,
			hostVideo: {},
			// 录播课程
			classroomList: [],
			// 招生运营服务项目
			projectList: [],
			// 资讯
			newList: [],
			// 专家
			zhuanLeft: [],
			prightDd: [],
			IsShowService: false, // 是否展示服务
			IsShowClassroom: false, // 是否展示录播
			IsShowHeadlines: false, // 是否展示头条
			IsShowMedia: false, // 是否展示媒体
			IsShowAppointment: false, // 是否展示专家
			IsShowActivity: false, // 是否展示活动
			ServiceName: '服务项目', // 服务名称
			ClassroomName: '录播课堂', // 录播名称
			HeadlinesName: '头条资讯', // 头条名称
			MediaName: '媒体报道', // 媒体名称
			AppointmentName: '专家预约', // 专家名称
			ActivityName: '活动报名', // 活动名称
			ProjectSetList: [],
			cardList: []
		};
	},
	computed: {
		swiper() {
			return this.$refs.mySwiper.swiper;
		},
		...mapState(['user'])
	},
	created() {
		this.getSavedLoginInfo();
	},
	mounted() {
		console.log('this is current swiper instance object', this.swiper);
		this.GetNavigation();
		this.GetBanner();
		this.GetNews();
		this.GetSidebar();
		this.GetSet();
		this.GetNewsTitle();
		this.GetHostVideo();
		this.GetProject();
		this.GetClassroom();
		this.GetHeadlines();
		this.GetAppointment();
		this.GetActivity();
		this.GetProjectSet();
		this.GetCardCategory();
	},
	methods: {
		// 获取卡片
		GetCardCategory: function() {
			var that = this;
			that.$api.HtppRequest(
				'WebsiteSet/CardCategory?isIndex=1',
				'GET',
				{},
				function(res) {
					console.log('获取卡片');
					console.log(res);
					if (res.code === 0) {
						var list = res.data;
						list = list.map(a => {
							if(a.Title=='智能填报'){
								a.Title='高效查'
							}
							a.Children.forEach(c => {
								that.KeyList.map(b => {
									if (c.Title === b.name) {
										c.Key = b.englishName;
										c.path = b.path;
										c.setId = b.id;
									}
								});
							});
							return a;
						});
						that.cardList = list;
						console.log('处理后的卡牌', that.cardList);
					}
				},
				function(res) {}
			);
		},
		// 智能填报
		gozntb(type, path, id) {
			var that = this;
			if (that.user.user) {
				if (!this.user.user || !this.user.user.CityCode) {
				    this.$confirm('您还未完善信息,请先完善！', '提示', {
				        confirmButtonText: '确定',
				        cancelButtonText: '取消',
				        type: 'warning'
				    }).then(() => {
				        this.$router.push('/datum');
				    }).catch(() => {
				    });
					return;
				}
				// 登录后判断是否有次数
				that.$api.HtppRequest(
					'Evaluation',
					'GET',
					{},
					function(res) {
						console.log('次数', res);
						if (res.code === 0) {
							// var data = res.data;
							const element = res.data[type+'Num'];
							const isInfinity = res.data[`Is${type}`];
							var num = isInfinity ? -1 : element;
							if (num !== 0) {
								
								that.$router.push({
									path: path,
									query: {
										key: type,
										id: id,
										type:type=='Voluntary'?1:type=='Voluntary2'?2:0
									}
								});
								
							} else {
								that.$router.push('/system');
							}
							return;
							// var nubr = 0;
							// // 高考选科测评
							// if (type === 'NewEvaluation') {
							// 	nubr = data.IsNewEvaluation ? 1 : data.NewEvaluationNum > 0 ? 1 : 0;
							// 	if (nubr > 0) {
							// 		that.$router.push({
							// 			path: '/gaokao',
							// 			query: {
							// 				key: 'NewEvaluation',
							// 				id: 1
							// 			}
							// 		});
							// 	} else {
							// 		that.$router.push('/system');
							// 	}
							// }
							// // 根据科目选专业
							// if (type === 'Major') {
							// 	nubr = data.IsMajor ? 1 : data.MajorNum > 0 ? 1 : 0;
							// 	if (nubr > 0) {
							// 		that.$router.push({
							// 			path: '/major',
							// 			query: {
							// 				key: 'Major'
							// 			}
							// 		});
							// 	} else {
							// 		that.$router.push('/system');
							// 	}
							// }
							// // 根据专业选科目
							// if (type === 'Subject') {
							// 	nubr = data.IsSubject ? 1 : data.SubjectNum > 0 ? 1 : 0;
							// 	if (nubr > 0) {
							// 		that.$router.push({
							// 			path: '/subject',
							// 			query: {
							// 				key: 'Subject'
							// 			}
							// 		});
							// 	} else {
							// 		that.$router.push('/system');
							// 	}
							// }
							// // 升学途径
							// if (type === 'Guide') {
							// 	nubr = data.IsGuide ? 1 : data.GuideNum > 0 ? 1 : 0;
							// 	if (nubr > 0) {
							// 		that.$router.push({
							// 			path: '/guide',
							// 			query: {
							// 				key: 'Guide'
							// 			}
							// 		});
							// 	} else {
							// 		that.$router.push('/system');
							// 	}
							// }
							// // 升学途径分析测评
							// if (type === 'Entrance') {
							// 	nubr = data.IsEntrance ? 1 : data.EntranceNum > 0 ? 1 : 0;
							// 	if (nubr > 0) {
							// 		that.$router.push({
							// 			path: '/way',
							// 			query: {
							// 				key: 'Entrance',
							// 				id: 2
							// 			}
							// 		});
							// 	} else {
							// 		that.$router.push('/system');
							// 	}
							// }
							// // 测评
							// if (type === 'Style') {
							// 	nubr = data.IsStyle ? 1 : data.StyleNum > 0 ? 1 : 0;
							// 	if (nubr > 0) {
							// 		that.$router.push({
							// 			path: '/style',
							// 			query: {
							// 				key: 'Style',
							// 				id: 3
							// 			}
							// 		});
							// 	} else {
							// 		that.$router.push('/system');
							// 	}
							// }
							// if (type === 'LearningTime') {
							// 	nubr = data.IsLearningTime ? 1 : data.LearningTimeNum > 0 ? 1 : 0;
							// 	if (nubr > 0) {
							// 		that.$router.push({
							// 			path: '/style',
							// 			query: {
							// 				key: 'LearningTime',
							// 				id: 4
							// 			}
							// 		});
							// 	} else {
							// 		that.$router.push('/system');
							// 	}
							// }
							// if (type === 'Psychological') {
							// 	nubr = data.IsPsychological ? 1 : data.PsychologicalNum > 0 ? 1 : 0;
							// 	if (nubr > 0) {
							// 		that.$router.push({
							// 			path: '/style',
							// 			query: {
							// 				key: 'Psychological',
							// 				id: 5
							// 			}
							// 		});
							// 	} else {
							// 		that.$router.push('/system');
							// 	}
							// }
							// if (type === 'EmotionManage') {
							// 	nubr = data.IsEmotionManage ? 1 : data.EmotionManageNum > 0 ? 1 : 0;
							// 	if (nubr > 0) {
							// 		that.$router.push({
							// 			path: '/style',
							// 			query: {
							// 				key: 'EmotionManage',
							// 				id: 6
							// 			}
							// 		});
							// 	} else {
							// 		that.$router.push('/system');
							// 	}
							// }
							// if (type === 'Comprehensive') {
							// 	nubr = data.IsComprehensive ? 1 : data.ComprehensiveNum > 0 ? 1 : 0;
							// 	if (nubr > 0) {
							// 		that.$router.push({
							// 			path: '/style',
							// 			query: {
							// 				key: 'Comprehensive',
							// 				id: 7
							// 			}
							// 		});
							// 	} else {
							// 		that.$router.push('/system');
							// 	}
							// }
							// if (type === 'Habit') {
							// 	nubr = data.IsHabit ? 1 : data.HabitNum > 0 ? 1 : 0;
							// 	if (nubr > 0) {
							// 		that.$router.push({
							// 			path: '/style',
							// 			query: {
							// 				key: 'Habit',
							// 				id: 8
							// 			}
							// 		});
							// 	} else {
							// 		that.$router.push('/system');
							// 	}
							// }
							// if (type === 'Motivation') {
							// 	nubr = data.IsMotivation ? 1 : data.MotivationNum > 0 ? 1 : 0;
							// 	if (nubr > 0) {
							// 		that.$router.push({
							// 			path: '/style',
							// 			query: {
							// 				key: 'Motivation',
							// 				id: 9
							// 			}
							// 		});
							// 	} else {
							// 		that.$router.push('/system');
							// 	}
							// }
							// if (type === 'StudySarason') {
							// 	nubr = data.IsStudySarason ? 1 : data.StudySarasonNum > 0 ? 1 : 0;
							// 	if (nubr > 0) {
							// 		that.$router.push({
							// 			path: '/style',
							// 			query: {
							// 				key: 'StudySarason',
							// 				id: 10
							// 			}
							// 		});
							// 	} else {
							// 		that.$router.push('/system');
							// 	}
							// }
							// if (type === 'Relationship') {
							// 	nubr = data.IsRelationship ? 1 : data.RelationshipNum > 0 ? 1 : 0;
							// 	if (nubr > 0) {
							// 		that.$router.push({
							// 			path: '/style',
							// 			query: {
							// 				key: 'Relationship',
							// 				id: 11
							// 			}
							// 		});
							// 	} else {
							// 		that.$router.push('/system');
							// 	}
							// }
							// if (type === 'Orientation') {
							// 	nubr = data.IsOrientation ? 1 : data.OrientationNum > 0 ? 1 : 0;
							// 	if (nubr > 0) {
							// 		that.$router.push({
							// 			path: '/style',
							// 			query: {
							// 				key: 'Orientation',
							// 				id: 13
							// 			}
							// 		});
							// 	} else {
							// 		that.$router.push('/system');
							// 	}
							// }
							// if (type === 'ShiEn') {
							// 	nubr = data.IsShiEn ? 1 : data.ShiEnNum > 0 ? 1 : 0;
							// 	if (nubr > 0) {
							// 		that.$router.push({
							// 			path: '/style',
							// 			query: {
							// 				key: 'ShiEn',
							// 				id: 14
							// 			}
							// 		});
							// 	} else {
							// 		that.$router.push('/system');
							// 	}
							// }
							// if (type === 'Temperament') {
							// 	nubr = data.IsTemperament ? 1 : data.TemperamentNum > 0 ? 1 : 0;
							// 	if (nubr > 0) {
							// 		that.$router.push({
							// 			path: '/style',
							// 			query: {
							// 				key: 'Temperament',
							// 				id: 15
							// 			}
							// 		});
							// 	} else {
							// 		that.$router.push('/system');
							// 	}
							// }
							// if (type === 'Shubo') {
							// 	nubr = data.IsShubo ? 1 : data.ShuboNum > 0 ? 1 : 0;
							// 	if (nubr > 0) {
							// 		that.$router.push({
							// 			path: '/style',
							// 			query: {
							// 				key: 'Shubo',
							// 				id: 16
							// 			}
							// 		});
							// 	} else {
							// 		that.$router.push('/system');
							// 	}
							// }
							// if (type === 'Usability') {
							// 	nubr = data.IsUsability ? 1 : data.UsabilityNum > 0 ? 1 : 0;
							// 	if (nubr > 0) {
							// 		that.$router.push({
							// 			path: '/style',
							// 			query: {
							// 				key: 'Usability',
							// 				id: 17
							// 			}
							// 		});
							// 	} else {
							// 		that.$router.push('/system');
							// 	}
							// }
							// if (type === 'Confidence') {
							// 	nubr = data.IsConfidence ? 1 : data.ConfidenceNum > 0 ? 1 : 0;
							// 	if (nubr > 0) {
							// 		that.$router.push({
							// 			path: '/style',
							// 			query: {
							// 				key: 'Confidence',
							// 				id: 18
							// 			}
							// 		});
							// 	} else {
							// 		that.$router.push('/system');
							// 	}
							// }
							// if (type === 'EQ') {
							// 	nubr = data.IsEQ ? 1 : data.EQNum > 0 ? 1 : 0;
							// 	if (nubr > 0) {
							// 		that.$router.push({
							// 			path: '/style',
							// 			query: {
							// 				key: 'EQ',
							// 				id: 19
							// 			}
							// 		});
							// 	} else {
							// 		that.$router.push('/system');
							// 	}
							// }
							// if (type === 'DISC') {
							// 	nubr = data.IsDISC ? 1 : data.DISCNum > 0 ? 1 : 0;
							// 	if (nubr > 0) {
							// 		that.$router.push({
							// 			path: '/style',
							// 			query: {
							// 				key: 'DISC',
							// 				id: 20
							// 			}
							// 		});
							// 	} else {
							// 		that.$router.push('/system');
							// 	}
							// }
							// if (type === 'ProfessionalPDP') {
							// 	nubr = data.IsProfessionalPDP ? 1 : data.ProfessionalPDPNum > 0 ? 1 : 0;
							// 	if (nubr > 0) {
							// 		that.$router.push({
							// 			path: '/style',
							// 			query: {
							// 				key: 'ProfessionalPDP',
							// 				id: 21
							// 			}
							// 		});
							// 	} else {
							// 		that.$router.push('/system');
							// 	}
							// }
							// if (type === 'ParentPDP') {
							// 	nubr = data.IsParentPDP ? 1 : data.ParentPDPNum > 0 ? 1 : 0;
							// 	if (nubr > 0) {
							// 		that.$router.push({
							// 			path: '/style',
							// 			query: {
							// 				key: 'ParentPDP',
							// 				id: 12
							// 			}
							// 		});
							// 	} else {
							// 		that.$router.push('/system');
							// 	}
							// }
							// // 学生档案
							// if (type === 'ArchivesPDP') {
							// 	nubr = data.IsArchivesPDP ? 1 : data.ArchivesPDPNum > 0 ? 1 : 0;
							// 	if (nubr > 0) {
							// 		that.$router.push({
							// 			path: '/fileindex',
							// 			query: {
							// 				key: 'ArchivesPDP'
							// 			}
							// 		});
							// 	} else {
							// 		that.$router.push('/system');
							// 	}
							// }
							// // 智能填报测评
							// if (type === 'UniversityScore') {
							// 	nubr = data.IsUniversityScore ? 1 : data.UniversityScoreNum > 0 ? 1 : 0;
							// 	if (nubr > 0) {
							// 		that.$router.push({
							// 			path: '/lastIndex',
							// 			query: {
							// 				key: 'UniversityScore'
							// 			}
							// 		});
							// 	} else {
							// 		that.$router.push('/system');
							// 	}
							// }
							// // 专业分数线
							// if (type === 'MajorScore') {
							// 	nubr = data.IsMajorScore ? 1 : data.MajorScoreNum > 0 ? 1 : 0;
							// 	if (nubr > 0) {
							// 		that.$router.push({
							// 			path: '/majorScore',
							// 			query: {
							// 				key: 'MajorScore'
							// 			}
							// 		});
							// 	} else {
							// 		that.$router.push('/system');
							// 	}
							// }
							// // 省控分数线
							// if (type === 'Provincial') {
							// 	nubr = data.IsProvincial ? 1 : data.ProvincialNum > 0 ? 1 : 0;
							// 	if (nubr > 0) {
							// 		that.$router.push({
							// 			path: '/skScore',
							// 			query: {
							// 				key: 'Provincial'
							// 			}
							// 		});
							// 	} else {
							// 		that.$router.push('/system');
							// 	}
							// }
							// // 一分一段表
							// if (type === 'Paragraph') {
							// 	nubr = data.IsParagraph ? 1 : data.ParagraphNum > 0 ? 1 : 0;
							// 	if (nubr > 0) {
							// 		that.$router.push({
							// 			path: '/scoreTable',
							// 			query: {
							// 				key: 'Paragraph'
							// 			}
							// 		});
							// 	} else {
							// 		that.$router.push('/system');
							// 	}
							// }
							// // 高校查询
							// if (type === 'University') {
							// 	nubr = data.IsUniversity ? 1 : data.UniversityNum > 0 ? 1 : 0;
							// 	if (nubr > 0) {
							// 		that.$router.push({
							// 			path: '/lastSchool',
							// 			query: {
							// 				key: 'University'
							// 			}
							// 		});
							// 	} else {
							// 		that.$router.push('/system');
							// 	}
							// }
							// // 大学排名
							// if (type === 'UniversityRank') {
							// 	nubr = data.IsUniversityRank ? 1 : data.UniversityRankNum > 0 ? 1 : 0;
							// 	if (nubr > 0) {
							// 		that.$router.push({
							// 			path: '/lastRanking',
							// 			query: {
							// 				key: 'UniversityRank'
							// 			}
							// 		});
							// 	} else {
							// 		that.$router.push('/system');
							// 	}
							// }
							// // 专业查询
							// if (type === 'ProfessionalInquiry') {
							// 	nubr = data.IsProfessionalInquiry ? 1 : data.ProfessionalInquiryNum > 0 ? 1 : 0;
							// 	if (nubr > 0) {
							// 		that.$router.push({
							// 			path: '/lastMajor',
							// 			query: {
							// 				key: 'ProfessionalInquiry'
							// 			}
							// 		});
							// 	} else {
							// 		that.$router.push('/system');
							// 	}
							// }
							// // 职业查询
							// if (type === 'OccupationInquiry') {
							// 	nubr = data.IsOccupationInquiry ? 1 : data.OccupationInquiryNum > 0 ? 1 : 0;
							// 	if (nubr > 0) {
							// 		that.$router.push({
							// 			path: '/occupation',
							// 			query: {
							// 				key: 'OccupationInquiry'
							// 			}
							// 		});
							// 	} else {
							// 		that.$router.push('/system');
							// 	}
							// }
							// // 招生章程
							// if (type === 'Admission') {
							// 	nubr = data.IsAdmission ? 1 : data.AdmissionNum > 0 ? 1 : 0;
							// 	if (nubr > 0) {
							// 		that.$router.push({
							// 			path: '/constitution',
							// 			query: {
							// 				key: 'Admission'
							// 			}
							// 		});
							// 	} else {
							// 		that.$router.push('/system');
							// 	}
							// }
							// // 智能选院校
							// if (type === 'Colleges') {
							// 	nubr = data.IsColleges ? 1 : data.CollegesNum > 0 ? 1 : 0;
							// 	if (nubr > 0) {
							// 		that.$router.push({
							// 			path: '/znYuan',
							// 			query: {
							// 				key: 'Colleges'
							// 			}
							// 		});
							// 	} else {
							// 		that.$router.push('/system');
							// 	}
							// }
							// // 智能选专业
							// if (type === 'MajorSelect') {
							// 	nubr = data.IsMajorSelect ? 1 : data.MajorSelectNum > 0 ? 1 : 0;
							// 	if (nubr > 0) {
							// 		that.$router.push({
							// 			path: '/znZhuan',
							// 			query: {
							// 				key: 'MajorSelect'
							// 			}
							// 		});
							// 	} else {
							// 		that.$router.push('/system');
							// 	}
							// }
							// // 录取风险评估
							// if (type === 'AdmissionRisk') {
							// 	nubr = data.IsAdmissionRisk ? 1 : data.AdmissionRiskNum > 0 ? 1 : 0;
							// 	if (nubr > 0) {
							// 		that.$router.push({
							// 			path: '/assessment',
							// 			query: {
							// 				key: 'AdmissionRisk'
							// 			}
							// 		});
							// 	} else {
							// 		that.$router.push('/system');
							// 	}
							// }
							// // 同分数考生去向
							// if (type === 'Whereabout') {
							// 	nubr = data.IsWhereabout ? 1 : data.WhereaboutNum > 0 ? 1 : 0;
							// 	if (nubr > 0) {
							// 		that.$router.push({
							// 			path: '/lastGo',
							// 			query: {
							// 				key: 'Whereabout'
							// 			}
							// 		});
							// 	} else {
							// 		that.$router.push('/system');
							// 	}
							// }
							// // 一键自能填报
							// if (type === 'Voluntary') {
							// 	nubr = data.IsVoluntary ? 1 : data.VoluntaryNum > 0 ? 1 : 0;
							// 	if (nubr > 0) {
							// 		that.$router.push({
							// 			path: '/xzTianBaoIndex',
							// 			query: {
							// 				key: 'Voluntary'
							// 			}
							// 		});
							// 	} else {
							// 		that.$router.push('/system');
							// 	}
							// }
						}
					},
					function(res) {}
				);
			} else {
				// 缓存数据登录后跳转
				Cookies.set('Evaluation_key', type);
				// 没有登录去登录
				that.$router.push('/login');
			}
		},
		// 服务
		fuwuTo(id) {
			console.log('1');
			this.$router.push({
				path: '/fuWuxq',
				query: {
					Id: id
				}
			});
		},
		// 录播
		luboTo(id) {
			console.log('2');
			this.$router.push({
				path: '/luboxq',
				query: {
					Id: id
				}
			});
		},
		// 资讯
		moreTo() {
			console.log('3');
			this.$router.push('/moreList');
		},
		// 资讯详情
		headDetails(id) {
			this.$router.push({
				path: '/headDetails',
				query: {
					Id: id
				}
			});
		},
		// 专家
		zhuanjiaTo() {
			console.log('4');
			this.$router.push('/zhuanjiaTo');
		},
		// 活动
		huodongTo(id) {
			console.log('5');
			this.$router.push({
				path: '/huoDongTo',
				query: {
					Id: id
				}
			});
		},
		// 申请
		shenqingBtn() {
			this.isShenqin = true;
		},
		// 关闭申请
		closeApply() {
			this.isShenqin = false;
		},
		// 倒计时
		backTime() {
			var that = this;
			if (!that.timer) {
				that.count = TIME_COUNT;
				that.show = false;
				that.timer = setInterval(() => {
					if (that.count > 0 && that.count <= TIME_COUNT) {
						that.count--;
					} else {
						that.show = true;
						clearInterval(that.timer);
						that.timer = null;
					}
				}, 1000);
			}
		},
		// 获取保存的登录信息
		getSavedLoginInfo() {
			this.loginInfoModel = this.$util.getloginInfo();
			if (this.loginInfoModel) {
				this.loginModel.Phone = this.loginInfoModel.Phone;
				this.loginModel.Password = this.loginInfoModel.Password;
			}
		},
		// 忘记密码
		passWord() {
			this.$router.push('/passWord');
		},
		// 注册
		regsit() {
			this.$router.push('/regsit');
		},
		// 登录
		login() {
			if (this.loginInfoModel && this.loginModel.Phone === this.loginInfoModel.Phone && this.loginModel.Password === this.loginInfoModel.Password) {
				this.loginModel.Password = this.$util.decodePassword(this.loginModel.Password);
			}
			this.$api
				.login(this.loginModel)
				.then(res => {
					if (res.code === 0) {
						if (this.rememberLoginState) {
							this.$util.saveloginInfo(this.loginModel);
						}
						return Promise.resolve({
							username: res.data,
							password: '123456',
							grant_type: 'password'
						});
					} else if (res.code === 2) {
						this.$util.showError(res.msg || '登录失败');
						if (res.data) {
							setTimeout(() => {
								window.open(res.data);
							}, 1000);
						}
					} else {
						this.$util.showError(res.msg || '登录失败');
					}
					return Promise.reject(res.msg);
				})
				.then(res => {
					return getToken(res);
				})
				.then(() => {
					this.$store.dispatch('user/setLocalGuid');
					this.$router.push('/home');
				});
		},
		// 个人中心
		goMyCenter() {
			if (!this.$route.fullPath.includes('my')) {
				this.$router.push('/myIndex');
			}
		},
		// 显示或隐藏密码
		seeClick() {
			this.isSee = !this.isSee;
		},
		// 记住登录状态
		stateBtn() {
			this.rememberLoginState = !this.rememberLoginState;
		},
		callback() {},
		media() {
			this.$router.push('/media');
		},
		details(id) {
			this.$router.push({
				path: '/mediaDetails',
				query: {
					Id: id
				}
			});
		},
		// 获取首页图片
		GetNavigation: function() {
			var that = this;
			that.$api.HtppRequest(
				'WebsiteSet/GetNavigationDetail?position=1',
				'GET',
				{},
				function(res) {
					console.log('获取首页图片');
					console.log(res);
					if (res.code === 0) {
						that.homePicture = res.data;
					}
				},
				function(res) {}
			);
		},
		// 获取首页轮播图
		GetBanner: function() {
			var that = this;
			that.$api.HtppRequest(
				'WebsiteSet/GetPagePicture',
				'GET',
				{},
				function(res) {
					console.log('获取首页轮播图');
					console.log(res);
					if (res.code === 0) {
						var list = res.data;
						var newList = [];
						for (var i = 0; i < list.length; i++) {
							if (list[i].Type === 1 && list[i].Position !== 4) {
								newList.push(list[i]);
							}
						}
						that.bannerList = newList;
						that.swiper.slideTo(3, 1000, false);
						console.log(newList);
					}
				},
				function(res) {}
			);
		},
		GoUrl: function(url) {
			if (url && url.length > 0) {
				window.open(url);
			}
		},
		// 获取首页视频
		GetHostVideo: function() {
			var that = this;
			that.$api.HtppRequest(
				'WebsiteSet/GetHostVideo',
				'GET',
				{},
				function(res) {
					console.log('获取首页视频');
					console.log(res);
					if (res.code === 0) {
						that.hostVideo = res.data;
					}
				},
				function(res) {}
			);
		},
		// 获取首页新闻
		GetNews: function() {
			var that = this;
			that.$api.HtppRequest(
				'WebsiteSet/GetReport?size=7&page=1',
				'GET',
				{},
				function(res) {
					console.log('获取首页新闻');
					console.log(res);
					if (res.code === 0) {
						var list = res.data;
						var newList = [];
						for (var i = 0; i < list.length; i++) {
							if (i === 0) {
								that.firstMei = list[i];
							} else {
								newList.push(list[i]);
							}
						}
						that.meiList = newList;
					}
				},
				function(res) {}
			);
		},
		// 获取底图
		GetSidebar: function() {
			var that = this;
			that.$api.HtppRequest(
				'WebsiteSet/GetSidebar',
				'GET',
				{},
				function(res) {
					console.log('获取底图');
					console.log(res);
					if (res.code === 0) {
						that.sidebar = res.data;
					}
				},
				function(res) {}
			);
		},
		// 获取新闻标题
		GetNewsTitle: function() {
			var that = this;
			that.$api.HtppRequest(
				'WebsiteSet/GetNewsTitle',
				'GET',
				{},
				function(res) {
					console.log('获取新闻标题');
					console.log(res);
					if (res.code === 0) {
						that.newsTitle = res.data;
					}
				},
				function(res) {}
			);
		},
		// 获取配置信息
		GetSet: function() {
			var that = this;
			that.$api.HtppRequest(
				'WebsiteSet/GetWebSet',
				'GET',
				{},
				function(res) {
					console.log('获取配置信息');
					console.log(res);
					if (res.code === 0) {
						that.setInfo = res.data;
						that.$store.state.user.cardSaleStatus = res.data.CardSale;
					}
				},
				function(res) {}
			);
		},
		// 获取验证码
		GetCode: function() {
			var that = this;
			if (that.count > 0) {
				return;
			}
			console.log(that.phone);
			if (that.phone.length === 0) {
				this.$util.showError('请输入手机号');
				return;
			} else if (!/^1[3456789]\d{9}$/.test(that.phone)) {
				this.$util.showError('请输入合法手机号');
				return;
			}
			that.$api.HtppRequest(
				'Common/GetUserCode?type=3&phone=' + that.phone,
				'GET',
				{},
				function(res) {
					console.log('获取验证码');
					console.log(res);
					if (res.flag) {
						that.backCode = res.code;
						that.backTime();
					} else {
						this.$util.showError(res.msg);
					}
				},
				function(res) {}
			);
		},
		// 提交数据
		SubmitSave: function() {
			var that = this;
			if (that.isClick) {
				return;
			}
			that.isClick = true;
			if (that.phone.length === 0) {
				this.$util.showError('请输入手机号');
				that.isClick = false;
				return;
			} else if (!/^1[3456789]\d{9}$/.test(that.phone)) {
				this.$util.showError('请输入合法手机号');
				that.isClick = false;
				return;
			}
			if (that.name.length === 0) {
				this.$util.showError('请输入用户名');
				return;
			}
			if (that.code.length === 0) {
				this.$util.showError('请输入验证码');
				that.isClick = false;
				return;
			}
			if (that.code !== that.backCode) {
				this.$util.showError('验证码错误');
				that.isClick = false;
				return;
			}
			that.$api.HtppRequest(
				'SystemData/AddUserConsultation?UserName=' + that.name + '&UserPhone=' + that.phone,
				'POST',
				{},
				function(res) {
					console.log('提交数据');
					console.log(res);
					if (res.flag) {
						that.$util.showOk('提交成功');
						setTimeout(function() {
							that.isClick = false;
							that.closeApply();
						}, 1000);
					} else {
						that.$util.showError(res.msg);
						that.isClick = false;
					}
				},
				function(res) {
					that.isClick = false;
				}
			);
		},
		// 获取首页录播项目
		GetClassroom: function() {
			var that = this;
			that.$api.HtppRequest(
				'WebsiteSet/GetClassroom?size=9999&page=1',
				'GET',
				{},
				function(res) {
					console.log('获取首页录播项目');
					console.log(res);
					if (res.code === 0) {
						that.classroomList = res.data;
					}
				},
				function(res) {}
			);
		},
		// 获取首页服务项目
		GetProject: function() {
			var that = this;
			that.$api.HtppRequest(
				'WebsiteSet/GetProject?size=9999&page=1',
				'GET',
				{},
				function(res) {
					console.log('获取首页服务项目');
					console.log(res);
					if (res.code === 0) {
						that.projectList = res.data;
					}
				},
				function(res) {}
			);
		},
		// 获取首页头条资讯
		GetHeadlines: function() {
			var that = this;
			that.$api.HtppRequest(
				'WebsiteSet/GetHeadlines?size=10&page=1',
				'GET',
				{},
				function(res) {
					console.log('获取首页头条资讯');
					console.log(res);
					if (res.code === 0) {
						that.newList = res.data;
					}
				},
				function(res) {}
			);
		},
		// 获取首页专家预约
		GetAppointment: function() {
			var that = this;
			that.$api.HtppRequest(
				'WebsiteSet/GetAppointment?size=10&page=1',
				'GET',
				{},
				function(res) {
					console.log('获取首页专家预约');
					console.log(res);
					if (res.code === 0) {
						that.zhuanLeft = res.data;
					}
				},
				function(res) {}
			);
		},
		// 获取首页活动报名
		GetActivity: function() {
			var that = this;
			that.$api.HtppRequest(
				'WebsiteSet/GetActivity?size=9999&page=1',
				'GET',
				{},
				function(res) {
					console.log('获取首页活动报名');
					console.log(res);
					if (res.code === 0) {
						that.prightDd = res.data;
					}
				},
				function(res) {}
			);
		},
		// 获取首页开启状态
		GetProjectSet: function() {
			var that = this;
			that.$api.HtppRequest(
				'WebsiteSet/GetProjectSet',
				'GET',
				{},
				function(res) {
					console.log('获取首页开启状态');
					console.log(res);
					if (res.code === 0) {
						var list = res.data;
						for (var i = 0; i < list.length; i++) {
							// 1.服务项目 2.录播课堂 3.专家预约 4.活动报名 5.头条资讯 6.媒体报道 7.友情链接 8.用户协议
							if (list[i].type === 1) {
								that.IsShowService = list[i].IsPublish;
								that.ServiceName = list[i].Name;
							} else if (list[i].type === 2) {
								that.IsShowClassroom = list[i].IsPublish;
								that.ClassroomName = list[i].Name;
							} else if (list[i].type === 3) {
								that.IsShowAppointment = list[i].IsPublish;
								that.AppointmentName = list[i].Name;
							} else if (list[i].type === 4) {
								that.IsShowActivity = list[i].IsPublish;
								that.ActivityName = list[i].Name;
							} else if (list[i].type === 5) {
								that.IsShowHeadlines = list[i].IsPublish;
								that.HeadlinesName = list[i].Name;
							} else if (list[i].type === 6) {
								that.IsShowMedia = list[i].IsPublish;
								that.MediaName = list[i].Name;
							}
							that.ProjectSetList = list;
						}
					}
				},
				function(res) {}
			);
		}
	}
};
</script>
<style scoped>
.home_icon_li span {
	display: block !important;
}

.el-dropdown-link {
	font-size: 16px;
	color: #000;
}

.home_icon_li img {
	display: block;
	width: 82px;
	height: 82px;
	margin: 0 auto 14px auto;
}

.home_icon_li {
	width: 20%;
	padding-top: 50px;
}

.home_icon {
	width: 1200px;
	background-color: #fff;
	padding-bottom: 40px;
	margin: 16px auto 60px auto;
}

.hpme_btn {
	margin-top: 20px;
	width: 100%;
	height: 40px;
	background-color: #fff;
	font-size: 16px;
	color: #000;
	text-align: center;
	line-height: 40px;
	border-radius: 4px;
}

.hpme_duo /deep/ .el-checkbox {
	width: 50%;
	margin-right: 0px !important;
}

/deep/.el-checkbox__original {
	width: auto !important;
	height: auto !important;
}

.hpme_duo /deep/.el-checkbox__label {
	color: #fff;
}

.hpme_duo /deep/.el-checkbox {
	margin-top: 10px;
}

.hpme_ke p {
	color: #939393;
	font-size: 14px;
	padding-top: 15px;
}

.hpme_li input {
	display: block;
	font-size: 14px;
	color: #fff;
	flex: 1;
}

.hpme_li input::-webkit-input-placeholder {
	color: #939393;
}

.hpme_li input:-moz-placeholder {
	color: #939393;
}

.hpme_li input:-ms-input-placeholder {
	color: #939393;
}

input[type='number']::-webkit-outer-spin-button,
input[type='number']::-webkit-inner-spin-button {
	-webkit-appearance: none !important;
	margin: 0;
}

input[type='number'] {
	-moz-appearance: textfield;
}

.hpme_li span {
	font-size: 14px;
	color: #fff;
	position: absolute;
	right: 0;
	bottom: 5px;
	margin-bottom: 0;
	z-index: 1;
}

.hpme_li {
	border-bottom: solid 1px #ffffff;
	padding: 30px 0 10px 0;
	position: relative;
}

.home-logoin > h6 span {
	width: 20px;
	height: 1px;
	display: inline-block;
	background-color: #ffffff;
	margin: 0 8px;
}

.home-logoin > h6 {
	font-size: 16px;
	color: #fff;
	text-align: center;
	padding-top: 17px;
	font-weight: normal;
}

/* 2.22 */

.phuo_gao {
	/* height: 747px; */
	overflow: auto;
}

.phuo_gao::-webkit-scrollbar-track-piece {
	background-color: #f8f8f8;
}

.phuo_gao::-webkit-scrollbar {
	width: 4px;
	height: 9px;
}

.phuo_gao::-webkit-scrollbar-thumb {
	background-color: #333;
	background-clip: padding-box;
	min-height: 28px;
}

.phuo_gao::-webkit-scrollbar-thumb:hover {
	background-color: #bbb;
}

.phuo_gao dd {
	margin-top: 20px;
	cursor: pointer;
}

.phuo_gao dd:hover,
.pright_top li:hover,
.new-list li:hover,
.project-list li:hover {
	opacity: 0.7;
}

.pright_head figure {
	cursor: pointer;
}

.phuo_gao figure figcaption {
	font-size: 14px;
	color: #808080;
}

.phuo_gao figure img {
	display: block;
	width: 24px;
	height: 24px;
	margin-right: 8px;
}

.phuo_gao figure {
	margin-top: 10px;
}

.phuo_gao h1 {
	font-size: 14px;
	color: #333;
	margin-top: 20px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.phuo_gao dd > img {
	display: block;
	width: 100%;
	height: 120px;
	border-radius: 10px;
	overflow: hidden;
}

.pright_huo {
	margin-top: 20px;
}

/* pright_huo */

.pright_top li hgroup p {
	font-size: 14px;
	color: #808080;
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 2;
	overflow: hidden;
	margin-top: 10px;
	line-height: 24px;
}

.pright_top li:nth-child(n + 7) {
	display: none;
}

.pright_top li hgroup h6 {
	font-size: 14px;
	color: #333;
}

.pright_top li hgroup {
	width: calc(100% - 70px);
	padding-bottom: 20px;
	border-bottom: solid 1px #f5f5f5;
}

.pright_top li img {
	display: block;
	width: 60px;
	height: 60px;
	border-radius: 50px;
	overflow: hidden;
}

.pright_top li:nth-child(6) hgroup {
	border-bottom: none;
}

.pright_top li {
	padding-top: 20px;
	cursor: pointer;
}

/* pright_top */

.pright_head figure img {
	display: block;
	width: 24px;
	height: 24px;
}

.pright_head figure figcaption {
	font-size: 14px;
	color: #747474;
	margin-right: 0.5em;
}

.pright_head h6 {
	font-size: 16px;
	color: #333;
	padding-left: 10px;
	position: relative;
	font-weight: normal;
}

.pright_head h6::after {
	content: '';
	width: 4px;
	height: 16px;
	border-radius: 50px;
	background-color: #444444;
	position: absolute;
	left: 0;
	top: 50%;
	margin-top: -8px;
	z-index: 1;
}

.pright_top {
	width: 100%;
	padding: 20px 18px;
	border: solid 1px #f5f5f5;
	border-radius: 10px;
}

/* pright_top */

/* recruit */
.recruit {
	padding: 20px;
	height: auto;
	background-color: #fff;
}

/* recruit-left */
.recruit-left {
	width: 800px;
	height: auto;
}

.rct-left-tit {
	width: 100%;
	height: auto;
	border-bottom: 2px solid #e6e6e6;
	margin-bottom: 20px;
}

.rct-left-tit p {
	width: 150px;
	height: 40px;
	line-height: 40px;
	text-align: center;
	font-size: 16px;
	color: #fff;
	background-color: #444444;
	border-radius: 0px 15px 0 0;
}

.left-tit-more {
	display: flex;
	align-items: center;
	cursor: pointer;
}

.left-tit-more span {
	font-size: 14px;
	color: #333;
}

.left-tit-more img {
	width: 24px;
	height: 24px;
	display: block;
	margin-right: 5px;
}

.recruit-left-c01 {
	width: 100%;
	height: auto;
}

/* project-list */
.project-list {
	width: 100%;
	display: flex;
	flex-wrap: wrap;
}

.project-list li {
	width: 250px;
	height: auto;
	margin-right: 24px;
	margin-bottom: 25px;
	cursor: pointer;
}

.project-list li:nth-child(3n + 3) {
	margin-right: 0px;
}

.pj-img {
	width: 250px;
	height: 166px;
	background: url(../image/noa.png) no-repeat;
	background-size: 100% 100%;
	border-radius: 5px;
	margin-bottom: 10px;
}

.pj-img img {
	display: block;
	width: 100%;
	height: 100%;
	border-radius: 5px;
}

.pj-name {
	width: 100%;
	font-size: 14px;
	color: #333;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: normal;
	text-indent: 0.5em;
}

.pj-tit {
	width: 100%;
}

.pj-tit p {
	width: 60%;
	font-size: 14px;
	color: #333;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: normal;
}

.pj-num {
	width: 40%;
	display: flex;
	align-items: center;
	justify-content: flex-end;
}

.pj-num img {
	width: 24px;
	height: 24px;
	display: block;
}

.pj-num span {
	font-size: 12px;
	color: #666;
}

/* new-list */
.new-list {
	width: 100%;
	height: auto;
}

.new-list li {
	width: 100%;
	display: flex;
	margin-bottom: 20px;
	cursor: pointer;
}

.new-img {
	width: 140px;
	height: 90px;
	background: url(../image/noa.png) no-repeat;
	background-size: 100% 100%;
	border-radius: 5px;
	margin-right: 20px;
}

.new-img img {
	width: 100%;
	height: 100%;
	display: block;
	border-radius: 5px;
}

.new-con {
	width: calc(100% - 160px);
	height: auto;
}

.new-ctit {
	width: 100%;
	font-size: 16px;
	color: #333;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	margin-bottom: 15px;
}

.new-ctxt {
	width: 100%;
	font-size: 14px;
	color: #666;
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 2;
	overflow: hidden;
}

/* recruit-right */
.recruit-right {
	width: 345px;
	height: auto;
}

/* serve-popup */
.serve-popup {
	width: 400px;
	height: 320px;
	overflow: hidden;
	background: #fff;
	border-radius: 5px;
	position: fixed;
	top: 50%;
	left: 50%;
	z-index: 51;
	margin-top: -160px;
	margin-left: -200px;
}

.serve-pop-del {
	width: 100%;
	padding: 15px;
	display: flex;
	align-items: center;
	justify-content: flex-end;
}

.serve-pop-del img {
	width: 20px;
	height: 20px;
	display: block;
	cursor: pointer;
}

.serve-pop-from {
	width: 100%;
	padding: 0 30px;
	height: auto;
}

.serve-pop-from li {
	padding: 15px 0;
	width: 100%;
	display: flex;
	align-items: center;
	border-bottom: 1px solid #f5f5f5;
}

.serve-pop-from li > span {
	font-size: 14px;
	color: #666;
	display: block;
	width: 20%;
	text-align: left;
}

.serve-pop-from li input {
	font-size: 14px;
	color: #333;
}

.serve-pop-from li .li-inp {
	width: 40%;
}

.serve-pop-btn {
	width: 80%;
	font-size: 14px;
	color: #fff;
	background-color: #005371;
	border-radius: 50px;
	height: 44px;
	line-height: 44px;
	display: block;
	margin: 25px auto 0 auto;
	cursor: pointer;
}

.code-btn {
	width: 40%;
	text-align: right;
	cursor: pointer;
}

.code-btn span {
	font-size: 14px;
	color: #005270;
}

.serve-pop-from li input::-webkit-input-placeholder {
	color: #999;
}

.serve-pop-from li input:-moz-placeholder {
	color: #999;
}

.serve-pop-from li input:-ms-input-placeholder {
	color: #999;
}

/* home-apply-con */
.home-apply-con {
	position: relative;
	width: 1200px;
	margin: 0 auto;
}

.home-apply {
	position: absolute;
	right: 0;
	bottom: 0;
	z-index: 2;
	height: auto;
	border-radius: 10px;
	display: flex;
	align-items: center;
	padding: 40px 0;
	margin-right: 40px;
	margin-bottom: 50px;
}

.home-apply-left {
	width: 280px;
	height: auto;
	border-right: 1px solid #1a657f;
}

.apply-left-li {
	display: flex;
	justify-content: center;
}

.apply-left-li > img {
	width: 32px;
	height: 32px;
	display: block;
	margin-right: 10px;
}

.apply-left-c01 {
	height: auto;
}

.apply-left-c01 span {
	width: 100%;
	display: block;
	font-size: 18px;
	color: #333;
}

.apply-left-c01 .on-phone {
	font-size: 22px;
}

.home-apply-left > button {
	width: 160px;
	height: 50px;
	line-height: 50px;
	text-align: center;
	font-size: 15px;
	color: #fff;
	background: linear-gradient(to right, #f78c31, #ffa62a);
	border-radius: 50px;
	margin: 40px auto 0 auto;
	display: block;
	cursor: pointer;
}

.home-apply-right {
	width: 200px;
	height: auto;
}

.home-apply-right img {
	width: 130px;
	height: 130px;
	display: block;
	margin: 0 auto;
}

.home-apply-right span {
	font-size: 15px;
	color: #fff;
	text-align: center;
	display: block;
	width: 100%;
	margin-top: 10px;
}

/* home-logoin */

.home-logoin > img {
	display: block;
	width: 100%;
	height: 100%;
	position: absolute;
	left: 0;
	top: 0;
	z-index: -1;
	opacity: 0.4;
}

.home-logoin {
	width: 280px;
	height: auto;
	/* height: 300px; */
	background: rgba(0, 0, 0, 0.7);
	border-radius: 10px;
	position: absolute;
	top: 50%;
	right: 0;
	z-index: 10;
	padding: 0 30px 30px 30px;
	margin-top: -190px;
	margin-right: 12%;
}

.home-lgtit {
	width: 100%;
	text-align: center;
	font-size: 15px;
	color: #fff;
	position: relative;
	margin: 20px 0 10px 0;
}

.home-lgtit::after {
	position: absolute;
	content: '';
	width: 20px;
	height: 0px;
	border-bottom: 2px solid #fff;
	top: 50%;
	left: 50%;
	margin-left: 70px;
}

.home-lgtit::before {
	position: absolute;
	content: '';
	width: 20px;
	height: 0px;
	border-bottom: 2px solid #fff;
	top: 50%;
	right: 50%;
	margin-right: 70px;
}

.banner-right {
	width: 100%;
	height: auto;
}

.banner-right-c01 {
	width: 100%;
	padding: 10px;
	height: auto;
	border-bottom: 1px solid #fff;
	display: flex;
	align-items: center;
}

.banner-right-c01:last-child {
	border-bottom: none;
	padding: 20px 10px;
	cursor: pointer;
}

.banner-right-c01 > img {
	width: 20px;
	height: 20px;
	display: block;
}

.banner-right-c01 > input {
	margin-left: 10px;
	width: 100%;
	font-size: 15px;
	color: #fff;
}

.banner-right-c01 > span {
	font-size: 14px;
	color: #fff;
	display: block;
	margin-left: 10px;
}

.banner-right-btn {
	width: 100%;
	height: 40px;
	line-height: 40px;
	text-align: center;
	background: #fff;
	color: #000;
	text-align: center;
	font-size: 14px;
	border-radius: 5px;
	cursor: pointer;
}

.banner-rfoot {
	width: 100%;
	display: flex;
	align-items: center;
	margin-top: 20px;
}

.banner-rfoot p {
	width: 50%;
	text-align: center;
	font-size: 14px;
	color: #fff;
	border-right: 2px solid #a4a5a6;
	cursor: pointer;
}

.banner-rfoot p:last-child {
	border-right: none;
}

.hmei_fg img {
	display: block;
	width: 16px;
	height: 9px;
}

.hmei_fg p {
	font-size: 14px;
	margin-right: 10px;
}

.hmei_fg {
	width: 240px;
	height: 40px;
	border-radius: 4px;
	border: solid 1px #e6e6e6;
	margin: 60px auto 0 auto;
	cursor: pointer;
}

.hmei_fg:hover {
	opacity: 0.7;
}

.home_mei_right hgroup p {
	color: #666666;
	font-size: 14px;
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 3;
	overflow: hidden;
	margin-top: 10px;
	position: relative;
	height: 63px;
}

.home_mei_right hgroup p::after {
	content: '...';
	text-align: right;
	position: absolute;
	bottom: -4px;
	right: 0;
	width: 10%;
	height: 1.8em;
}

.home_mei_right hgroup {
	overflow: hidden;
	width: calc(100% - 160px);
}

.home_mei_right hgroup h6 {
	font-size: 16px;
	font-weight: normal;
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 2;
	overflow: hidden;
	min-height: 47px;
}

.hmei_pic img {
	display: block;
	width: 100%;
	height: 100%;
}

.hmei_pic {
	overflow: hidden;
	border-radius: 6px;
	width: 140px;
	height: 100px;
	background: url(../image/nob.png) no-repeat center center;
	background-size: 100% 100%;
}

.home_mei_right ul li:nth-child(n + 3) {
	margin-top: 50px;
}

.home_mei_right ul li:nth-child(n + 7) {
	display: none;
}

.home_mei_right ul li {
	overflow: hidden;
	width: 48%;
	float: left;
	cursor: pointer;
}

.home_mei_right ul li:hover {
	opacity: 0.7;
}

.home_mei_right ul li:nth-of-type(even) {
	float: right;
}

.home_mei_right ul {
	overflow: hidden;
}

.home_mei_right {
	overflow: hidden;
	width: calc(100% - 404px);
}

/* home_mei_right */

.home_mei_left p i {
	font-style: normal;
	cursor: pointer;
}

.home_mei_left p i:hover {
	opacity: 0.7;
}

.home_mei_left p span {
	color: #666666;
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 3;
	overflow: hidden;
}

.home_mei_left p {
	font-size: 14px;
	color: #005371;
	line-height: 20px;
}

.home_mei_left h6 {
	font-size: 16px;
	margin: 20px 0;
	text-align: left;
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 2;
	overflow: hidden;
	font-weight: normal;
}

.home_mei_left img {
	display: block;
	width: 350px;
	height: 250px;
	border-radius: 6px;
}

.home_mei_left {
	overflow: hidden;
	width: 350px;
}

.home_mei_div {
	overflow: hidden;
	margin-top: 60px;
}

/* home_mei_div */

.home_mei > img {
	width: 143px;
	height: 40px;
	display: block;
	margin: 0 auto;
}

.home_mei > h4 {
	font-size: 32px;
	color: #333;
	text-align: center;
}

.home_mei {
	overflow: hidden;
	margin-top: 30px;
}

/* home_mei */

.home_saas > img {
	display: block;
	width: 100%;
}

.home_saas {
	overflow: hidden;
}

/* home_saas */

.homeNei {
	overflow: hidden;
	width: 100%;
	margin: 0px auto;
}

/* homeNei */

* >>> .swiper-pagination-bullet {
	width: 20px !important;
	height: 10px !important;
	border-radius: 50px;
	background-color: rgba(255, 255, 255, 0.7);
}

* >>> .swiper-pagination-bullet-active {
	background-color: #fff;
}

.banner {
	overflow: hidden;
	height: auto;
	max-height: 694px;
	background: url(../image/AI-banner.png) no-repeat left center;
	background-size: 100% 100%;
	position: relative;
}

.swiper-slide img {
	width: 100%;
	height: 100%;
	display: block;
}

.pvideo {
	width: 100%;
	padding: 80px 0;
	overflow: hidden;
	position: relative;
}

.pvideo > img {
	display: block;
	width: 100%;
	height: 100%;
	position: absolute;
	left: 0;
	top: 0;
	z-index: 1;
}

.pvideo > video {
	position: relative;
	z-index: 2;
	width: 968px;
	height: 545px;
	background-color: #333;
}
</style>
